export const TIME_RANGE_FIELD_SEPARATOR = '/'
